import { render, staticRenderFns } from "./Starextra.vue?vue&type=template&id=0bc17d12&"
import script from "./Starextra.vue?vue&type=script&lang=js&"
export * from "./Starextra.vue?vue&type=script&lang=js&"
import style0 from "./Starextra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports